function CHFrBodyHowitWorks() {
  return (
    <>
      <div className="container-fluid p-4 body-font">
        <div className="row">
          <div className="col-xs-12 col-md-6 py-md-5">
            <p className="h6">
              <b>Comment ça marche</b>
            </p>
            <p className="h1">
              <i>
                <b>Premiers pas avec Hertz 24/7</b>
              </i>
            </p>
            <p className="h6">
              L’utilisation de Hertz 24/7® est simple. Créez simplement votre
              profil de membre et accédez à tous les véhicules Hertz 24/7®
              disponibles chez nos différents partenaires en Europe.
            </p>
            <p className="h6">
              Tout ce dont vous avez besoin, c’est de notre application gratuite
              Hertz 24/7®. Saisissez vos informations une seule fois,
              téléchargez vos documents pour vérification, et c’est parti !
            </p>
          </div>
          <div className="col-xs-12 col-md-6" style={{ textAlign: "right" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/howitworks-top.png"
              alt=""
            />
          </div>
        </div>

        <div className="row" style={{ backgroundColor: "#F3F3F3" }}>
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <h1 className="display-5">
              <b>Comment fonctionne Hertz 24/7®</b>
            </h1>
            <br />
            <p className="h6">
              Nous avons rendu la location avec Hertz 24/7® tellement simple et
              rapide que vous pouvez être au volant en moins de 15 minutes.
              Voici comment cela fonctionne.
            </p>
            <br />
          </div>
        </div>

        <div className="row" style={{ backgroundColor: "#F3F3F3" }}>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/QR_large.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>01</b>
            </p>
            <br />
            <p className="h2">Téléchargez l’application</p>
            <p>
              Vous pouvez télécharger rapidement et facilement l’application
              Hertz 24/7 depuis votre app store en scannant le code QR
            </p>
          </div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              style={{ width: "240px", borderRadius: "15px" }}
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/de-de/static/247_DL_CH.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>02</b>
            </p>
            <br />
            <p className="h2">Inscription</p>
            <p>
              Créez simplement votre profil de membre et envoyez vos documents
              pour vérification à l’aide de la fonction photo intégrée à
              l’application.
            </p>
          </div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              style={{
                width: "260px",
                borderRadius: "15px",
                border: "1px solid #ccc",
              }}
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Select_Location_CH.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>03</b>
            </p>
            <br />
            <p className="h2">Réservez votre véhicule</p>
            <p>
              Connectez-vous à l’application et réservez votre véhicule en
              sélectionnant le lieu et l’heure de prise en charge souhaités.
              Vous aurez besoin d’une carte de crédit/débit ou d’un compte
              PayPal.
            </p>
          </div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Step4-Start.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>04</b>
            </p>
            <br />
            <p className="h2">Démarrer votre location</p>
            <p>
              Peu avant le début de votre location, un véhicule vous sera
              attribué. Lors de la prise en charge, vous recevrez la clé
              digitale dans l’application pour déverrouiller le véhicule.
            </p>
          </div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Step5-During.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>05</b>
            </p>
            <br />
            <p className="h2">Pendant votre location</p>
            <p>
              Si vous avez besoin de plus de temps pendant votre location, vous
              pouvez prolonger votre réservation. Vous pouvez également
              consulter votre contrat de location à tout moment. En cas
              d’inactivité, l’antidémarrage peut être activé. Utilisez le bouton
              d’alimentation dans l’application pour le désactiver.
            </p>
          </div>
          <div className="col-xs-12 col-md-4" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Step6-End.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>06</b>
            </p>
            <br />
            <p className="h2">Terminer votre location</p>
            <p>
              Lorsque vous avez terminé, finalisez la location en complétant les
              étapes de contrôle de fin et la checklist. Votre facture vous sera
              envoyée par e-mail dans les 48 heures et la caution sera libérée.
              Provide your feedback on BizChat
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <h1 className="display-5">
              <b>FAQs</b>
            </h1>
            <p className="h6"></p>
          </div>

          <div className="col-xs-12" style={{ textAlign: "left" }}>
            <br />
            <br />

            <div className="accordion p-4" id="accordionFlushExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse1"
                    aria-expanded="false"
                    aria-controls="flush-collapse1"
                  >
                    <b>Qu’est-ce que Hertz 24/7 ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse1"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading1"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Hertz 24/7® est le service d’autopartage de Hertz qui vous
                      offre confort et flexibilité pour accéder à une large
                      gamme de véhicules et d’utilitaires. Vous pouvez louer à
                      l’heure ou à la journée. La prise en charge est disponible
                      24h/24 et 7j/7 (selon les horaires d’ouverture du site
                      concerné). Avec Hertz 24/7, vous pouvez facilement
                      réserver et gérer votre location via l’application 24/7.
                      Notre objectif est que vous puissiez prendre la route dans
                      les 15 minutes suivant le téléchargement de l’application.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading2">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse2"
                    aria-expanded="false"
                    aria-controls="flush-collapse2"
                  >
                    <b>De quoi ai-je besoin pour utiliser Hertz 24/7 ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse2"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading2"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Pour utiliser Hertz 24/7, nous avons besoin des documents
                    suivants :
                    <br />
                    · Un permis de conduire valide et une pièce d’identité à
                    votre nom (ou un passeport accompagné d’un justificatif
                    d’adresse)
                    <br />
                    · Une carte de crédit, une carte de débit ou un compte
                    PayPal à votre nom
                    <br />
                    · Votre numéro de téléphone portable et votre adresse e-mail
                    personnelle
                    <br />
                    Lors de votre inscription, nous effectuons les vérifications
                    d’identité nécessaires avant de confirmer votre
                    enregistrement.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading3">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse3"
                    aria-expanded="false"
                    aria-controls="flush-collapse3"
                  >
                    <b>
                      Comment les frais me sont-ils facturés lorsque je réserve
                      une location Hertz 24/7 ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse3"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading3"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    48 heures avant le début de votre location, ou immédiatement
                    si celle-ci commence dans les 48 heures, nous demandons une
                    autorisation pouvant aller jusqu’à 200 % du coût initial sur
                    votre moyen de paiement. La réservation n’est confirmée
                    qu’une fois cette autorisation validée.
                    <br />
                    La préautorisation est libérée lors de l’émission de la
                    facture. Nous prélevons les frais de location et remboursons
                    le montant restant. Si le coût de la location dépasse le
                    montant de la caution, nous retiendrons le solde restant.
                    Veuillez noter que tout retard dans le remboursement de la
                    caution est dû à votre banque émettrice de carte de crédit
                    ou de débit.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading4">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse4"
                    aria-expanded="false"
                    aria-controls="flush-collapse4"
                  >
                    <b>Comment déverrouiller le véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse4"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading4"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    L’application Hertz 24/7 est votre clé digitale. Pour ouvrir
                    votre véhicule, rendez-vous dans l’onglet « Conduire »
                    pendant votre location et appuyez sur le bouton «
                    Déverrouiller ». Remarque : vous ne pouvez déverrouiller le
                    véhicule qu’une fois que la période de location a
                    officiellement commencé, que l’inspection est terminée et
                    que le contrat a été signé.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading5">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse5"
                    aria-expanded="false"
                    aria-controls="flush-collapse5"
                  >
                    <b>Qui prend en charge les frais de carburant ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse5"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading5"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Le carburant n’est pas inclus dans nos tarifs. Le véhicule
                    est fourni avec le plein et doit être restitué avec le
                    plein. Des exceptions peuvent s’appliquer pour les véhicules
                    électriques — veuillez consulter les détails de votre
                    réservation.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default CHFrBodyHowitWorks;
